// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"nq","contentFrame":"nr","buttonGroup":"ns","button":"nt","header":"nu","text":"nv","contentImage":"nw","closeButton":"nx"};